<ng-container *ngIf="product">
  <ng-container *ngIf="!hasExtras; then productWithoutExtras; else productWithExtras"></ng-container>
  <!-- Product without extras -->
  <ng-template #productWithoutExtras>
    <div class="product single">
      <!-- Header with image -->
      <header>
        <div *ngIf="displayHasImage && !isModeTwo" class="img extra-item">
          <img [src]="displayImagePath" class="ya_image">
        </div>
        <div *ngIf="!displayHasImage || isModeTwo" class="img noimg">
          <h3>{{product.label}}</h3>
        </div>
      </header>
      <!-- Content -->
      <div class="content single">
        <sot-scroller-vertical>
          <header>
            <h1>{{product.label}}</h1>
            <ng-container *ngIf="requiredPoints; then benefitPriceView; else defaultPriceView"></ng-container>
            <ng-template #benefitPriceView>
              <div class="product-detail__price">
                {{requiredPoints}}
                <span langkey="benefit_label_of_points"></span>
              </div>
            </ng-template>
            <ng-template #defaultPriceView>
              <div class="product-detail__price">
                {{tempBasket.getTotalSum() | price}}
              </div>
            </ng-template>
          </header>
          <p *ngIf="product.details.description">
            {{product.details.description}}
          </p>
          <!-- Tags -->
          <ng-container *ngIf="isItemTagEnabled">
            <div class="product-tag">
              <div class="tag" *ngFor="let tag of itemTagsViewModel" [id]="'productTag' + tag.id">
                <div class="tag-svg" [innerHTML]="tag.svg_html"></div>
              </div>
            </div>
          </ng-container>
          <!-- Base price & Deposit -->
          <ng-container *ngIf="(!requiredPoints &&(use_eCommerce && showBasePrice(product))) || product.has_deposit">
            <div class="product-content_info">
              <ng-container *ngIf="showBasePrice(product)">
                <div class="product-baseUnit">
                  <span *ngIf="extraBaseUnit(product) === baseUnit.PIECE">
                    {{(extraPricePerUnit(product)|price) + " /1" }}
                    <span langkey="details_baseunit_piece"></span>
                  </span>
                  <span *ngIf="extraBaseUnit(product) === baseUnit.LITER">
                    {{extraPricePerUnit(product)}} <span langkey="details_baseunit_liter"></span>
                  </span>
                  <span *ngIf="extraBaseUnit(product) === baseUnit.KILO">
                    {{extraPricePerUnit(product)}} <span langkey="details_baseunit_kilo"></span>
                  </span>
                </div>
              </ng-container>
              <ng-container *ngIf="product.has_deposit">
                <div class="deposit" [class.product-detail__deposit--custom]="product.extra.length > 5">
                  <span [langkey]="deposit_langkey"></span>
                  <span class="info-value">{{product.deposit | price:"p c"}}</span>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <sot-properties [product]="product"></sot-properties>
        </sot-scroller-vertical>
      </div>
      <!-- Footer with actions -->
      <footer class="product-detail__footer footer-single-content">
        <div class="buttons">
          <a class="btn goback" (click)="backToListBtn()">
            <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
            <span langkey="button_back"></span>
          </a>
          <a class="btn action" [class.disabled]="!canAddProductToBasket" (click)="checkRequirementAndAddToBasket()">
            <span langkey="button_add"></span>
            <div inlineSVG="sot/sot-icon.svg#sot-basket" flex [setSVGAttributes]="{class: 'basket-icon'}"></div>
          </a>
        </div>
      </footer>
    </div>
  </ng-template>
  <!-- Product with extras -->
  <ng-template #productWithExtras>
    <ng-container *ngIf="loadProductWithExtrasLayout; then productWithExtrasView; else productAdditionalInfoView">
    </ng-container>
    <ng-template #productWithExtrasView>
      <div class="product extra-item">
        <!-- Header with image -->
        <header>
          <div *ngIf="displayHasImage" class="img extra-item">
            <img [src]="displayImagePath" class="ya_image">
          </div>
          <div *ngIf="!displayHasImage" class="img noimg">
            <h3>{{product.label}}</h3>
          </div>
        </header>
        <!-- Content -->
        <div class="content single">
          <header>
            <h1>{{product.label}}</h1>
            <ng-container *ngIf="requiredPoints; then benefitPriceView; else defaultPriceView"></ng-container>
            <ng-template #benefitPriceView>
              <div class="product-detail__price">{{requiredPoints}} <span langkey="benefit_label_of_points"></span>
              </div>
            </ng-template>
            <ng-template #defaultPriceView>
              <div class="product-detail__price">{{getBasketProductShownBasePrice(tempBasket.products[0]) | price}}
              </div>
            </ng-template>
          </header>
          <div *ngIf="product.details.description" class="product-detail__description">
            <p>
              {{product.details.description}}
            </p>
          </div>
          <div class="product-detail__info-button">
            <a class="btn info" (click)="toggleProductAdditionalInfo(true);displayAdditionalInfo(product)"
              langkey="details_info"></a>
          </div>
          <!-- Extras container -->
          <div class="extras-container">
            <div class="process" [class.hideSteps]="extraGroups.length <= 1">
              <sot-scroller-vertical [class.customScroll]="product.details.description">
                <ng-container *ngFor="let extraGroup of extraGroups">
                  <!-- Extra group header -->
                  <div class="headline">
                    <h1>{{extraGroup.title}}</h1>
                    <div class="required" [class.obligation]="highlight_required">
                      <span>
                        <span [langkey]="extraGroup.force_mode ? 'details_obligation' : 'details_selection'"></span>:
                      </span>
                      {{getCount(extraGroup)}}/{{extraGroup.max_choices}}
                    </div>
                  </div>
                  <!-- Extra items -->
                  <div class="product-detail__extras-list"
                    [class.product-detail__extras-list--small]="extraGroup.extra_items.length > 5">
                    <ng-container *ngFor="let extra of extraGroup.extra_items">
                      <!-- Single extra (without subitems) -->
                      <ng-container *ngIf="extra.without_subitem; then SingleExtraTemplate else SubExtraTemplate">
                      </ng-container>
                      <ng-template #SingleExtraTemplate>
                        <div class="extra-item"
                          [class.noimg]="!extra.product || !extra.product.has_image || !extra_as_image"
                          [class.extra-item--unavailable]="!isExtraAvailable(extra) || fadeOutExtraBySelectedTag(extra)"
                          [class.extra-item--active]="isExtraSelected(extraGroup, extra) && !fadeOutExtraBySelectedTag(extra)"
                          (click)="fadeOutExtraBySelectedTag(extra) ? openResetExtraTagFilter(extra) : onItemClick($event, extraGroup, extra)">
                          <!-- Extra image -->
                          <div *ngIf="extra.product && extra.product.has_image && extra_as_image" class="img">
                            <img class="ya_image" [src]="extra.product.image_path">
                          </div>
                          <!-- Extra content -->
                          <div class="extra-content container">
                            <div class="top-content extra-content--top">
                              <header>
                                <h2>{{extra.title}}</h2>
                                <ng-container *ngIf="canDisplayAdditionalInformation(extra.product)">
                                  <div class="info-content">
                                    <a class="btn"
                                      (click)="toggleExtraAdditionalInfo(true);displayAdditionalInfo(extra.product, extra.price, $event)">
                                      <span>i</span>
                                    </a>
                                  </div>
                                </ng-container>
                              </header>
                              <p *ngIf="extra.product">
                                {{extra.product.details.description}}
                              </p>
                            </div>
                            <!-- Extra tags -->
                            <ng-container *ngIf="isItemTagEnabled">
                              <div class="extra-item-tags">
                                <div class="tag"
                                  *ngFor="let extra_tag of getExtraProductTagsByIds(extra.product.product_tag_ids)"
                                  [id]="'extraProductTag' + extra_tag.id">
                                  <div class="tag-svg" [innerHTML]="extra_tag.svg_html">
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <!-- Extra: Base price & Deposit -->
                            <ng-container
                              *ngIf=" (!requiredPoints &&(use_eCommerce && showBasePrice(extra.product))) || extra.has_deposit">
                              <div class="product-content_info">
                                <ng-container *ngIf="showBasePrice(extra.product)">
                                  <div class="product-baseUnit">
                                    <span *ngIf="extraBaseUnit(extra.product) === baseUnit.PIECE">
                                      {{(extraPricePerUnit(extra.product)|price) + " /1" }}
                                      <span langkey="details_baseunit_piece"></span>
                                    </span>
                                    <span *ngIf="extraBaseUnit(extra.product) === baseUnit.LITER">
                                      {{(extraPricePerUnit(extra.product)|price) + " /1" }}
                                      <span langkey="details_baseunit_liter"></span>
                                    </span>
                                    <span *ngIf="extraBaseUnit(extra.product) === baseUnit.KILO">
                                      {{(extraPricePerUnit(extra.product)|price) + " /1" }}
                                      <span langkey="details_baseunit_kilo"></span>
                                    </span>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="extra.has_deposit">
                                  <div class="deposit" [class.pdeposit-customized]="extra.sub_items.length > 5">
                                    <span [langkey]="deposit_langkey"></span>
                                    <span class="info-value">{{extra.deposit | price:"p c"}}</span>
                                  </div>
                                </ng-container>
                              </div>
                            </ng-container>
                            <!-- Extra footer with price and amount -->
                            <footer>
                              <div class="product-detail__price">
                                {{displayExtraPrice(extra.price) | price:"+p c"}}
                              </div>
                              <sot-amount *ngIf="extraGroup.max_choices >= 1" [amount]="getCount(extraGroup, extra)"
                                [max]="getCount(extraGroup, extra) + extraGroup.max_choices - getCount(extraGroup)"
                                (amountChange)="setExtraCountTo($event, extraGroup, extra)"
                                [class.small]="extraGroup.extra_items.length > 5">
                              </sot-amount>
                            </footer>
                            <!-- Unavailable overlay -->
                            <div *ngIf="!isExtraAvailable(extra)" class="not-available">
                              <span langkey="details_not_available"></span>
                            </div>
                            <div *ngIf="isExtraAvailable(extra) && fadeOutExtraBySelectedTag(extra)"
                              class="not-available">
                              <span langkey="tags_article_labeling_text"></span>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <!-- Sub extras template -->
                      <ng-template #SubExtraTemplate>
                        <ng-container *ngFor="let sub of extra.sub_items">
                          <div class="extra-item" (click)="onItemClick($event, extraGroup, extra, sub)"
                            [class.extra-item--unavailable]="!isExtraAvailable(extra)"
                            [class.extra-item--active]="isExtraSelected(extraGroup, extra, sub)">
                            <div *ngIf="sub.product && sub.product.has_image && extra_as_image" class="img">
                              <img class="ya_image" [src]="sub.product.image_path">
                            </div>
                            <div class="extra-content container">
                              <div class="top-content extra-content--top">
                                <header class="title">
                                  <h2>{{extra.title}} ({{sub.title}})</h2>
                                  <ng-container *ngIf="canDisplayAdditionalInformation(sub.product)">
                                    <div class="info-content">
                                      <a class="btn"
                                        (click)="toggleExtraAdditionalInfo(true);displayAdditionalInfo(sub.product,sub.price,$event)"><span>i</span></a>
                                    </div>
                                  </ng-container>
                                </header>
                                <p *ngIf="sub.product">{{sub.product.details.description}}</p>
                              </div>
                              <ng-container *ngIf="isItemTagEnabled">
                                <div class="extra-tag">
                                  <div class="tag"
                                    *ngFor="let extra_tag of getExtraProductTagsByIds(sub.product.product_tag_ids)"
                                    id="extraProductTag{{extra_tag.id}}">
                                    <div class="tag-svg" [innerHTML]="extra_tag.svg_html"></div>
                                  </div>
                                </div>
                              </ng-container>
                              <!--Extra: Base price & Deposit-->
                              <ng-container
                                *ngIf=" (!requiredPoints &&(use_eCommerce && showBasePrice(sub.product)))||sub.has_deposit">
                                <div class="product-content_info">
                                  <ng-container *ngIf="showBasePrice(sub.product)">
                                    <div class="product-baseUnit">
                                      <span *ngIf="extraBaseUnit(sub.product) === baseUnit.PIECE">
                                        {{(extraPricePerUnit(sub.product)|price) + " /1" }}
                                        <span langkey="details_baseunit_piece"></span>
                                      </span>
                                      <span *ngIf="extraBaseUnit(sub.product) === baseUnit.LITER">
                                        {{(extraPricePerUnit(sub.product)|price) + " /1" }}
                                        <span langkey="details_baseunit_liter"></span>
                                      </span>
                                      <span *ngIf="extraBaseUnit(sub.product) === baseUnit.KILO">
                                        {{(extraPricePerUnit(sub.product)|price) + " /1" }}
                                        <span langkey="details_baseunit_kilo"></span>
                                      </span>
                                    </div>
                                  </ng-container>
                                  <ng-container *ngIf="sub.has_deposit">
                                    <div class="deposit" [class.deposit-customized]="sub.sub_items.length > 5">
                                      <span [langkey]="deposit_langkey"></span>
                                      <span class="info-value">{{sub.deposit | price:"p c" }} </span>
                                    </div>
                                  </ng-container>
                                </div>
                              </ng-container>
                              <!--Sub item: footer with price and single or multiple selection -->
                              <footer>
                                <div class="product-detail__price">
                                  {{ displayExtraPrice(extra.price + sub.price) | price:"+p c"}}
                                </div>
                                <ng-container
                                  *ngIf="extraGroup.max_choices === 1;then singleSelection else multipleSelection">
                                </ng-container>
                                <ng-template #singleSelection>
                                  <a class="btn insert"
                                    [class.active]="!fadeOutExtraBySelectedTag(sub)&& isExtraSelected(extraGroup, extra, sub)">
                                    <div inlineSVG="sot/sot-icon.svg#sot-done" flex
                                      [setSVGAttributes]="{class: 'icon'}">
                                    </div>
                                  </a>
                                </ng-template>
                                <ng-template #multipleSelection>
                                  <div class="amount">
                                    <sot-amount *ngIf="extraGroup.max_choices >= 1"
                                      [amount]="getCount(extraGroup, extra, sub)"
                                      [max]="getCount(extraGroup, extra, sub) + extraGroup.max_choices - getCount(extraGroup)"
                                      (amountChange)="setExtraCountTo($event, extraGroup, extra, sub)"
                                      [class.small]="extraGroup.extra_items.length > 5">
                                    </sot-amount>
                                  </div>
                                </ng-template>
                              </footer>
                            </div>
                            <div *ngIf="!isExtraAvailable(extra, sub)" class="not-available">
                              <span langkey="details_not_available"></span>
                            </div>
                          </div>
                        </ng-container>
                      </ng-template>
                    </ng-container>
                  </div>
                </ng-container>
              </sot-scroller-vertical>
            </div>
          </div>
        </div>
        <!-- "Main" Footer with sum and actions -->
        <footer class="product-detail__footer">
          <div class="product-detail__sum">
            <span langkey="main_sum"></span>
            <ng-container *ngIf="requiredPoints; then benefitPriceView; else defaultPriceView"></ng-container>
            <ng-template #benefitPriceView>
              <div class="product-detail__price">{{requiredPoints}} <span langkey="benefit_label_of_points"></span>
              </div>
            </ng-template>
            <ng-template #defaultPriceView>
              <div class="product-detail__price">{{tempBasket.getTotalSum() | price}}</div>
            </ng-template>
          </div>
          <div class="buttons">
            <a class="btn goback" (click)="backToListBtn()">
              <div inlineSVG="sot/sot-icon.svg#sot-backward" flex [setSVGAttributes]="{class: 'btn-icon'}"></div>
              <span langkey="button_back"></span>
            </a>
            <a class="btn action" [class.disabled]="!canAddProductToBasket" (click)=" checkRequirementAndAddToBasket()">
              <span langkey="button_add"></span>
              <div inlineSVG="sot/sot-icon.svg#sot-basket" flex [setSVGAttributes]="{class: 'basket-icon'}"></div>
            </a>
          </div>
        </footer>
      </div>
    </ng-template>
    <ng-template #productAdditionalInfoView>
      <ng-container
        *ngIf="showProductAdditionalInfo; then ProductAdditionalInfoLayout; else ExtraAdditionalInfoLayout"></ng-container>
      <ng-template #ProductAdditionalInfoLayout>
        <sot-productAdditionalInfo [product]="selectedProduct"
          [toggleShowInfo]="toggleProductAdditionalInfo.bind(this,false)">
        </sot-productAdditionalInfo>
      </ng-template>
      <ng-template #ExtraAdditionalInfoLayout>
        <sot-productAdditionalInfo [product]="selectedProduct" [extraPrice]="extraProductPrice"
          [toggleShowInfo]="toggleExtraAdditionalInfo.bind(this,false)">
        </sot-productAdditionalInfo>
      </ng-template>
    </ng-template>
  </ng-template>
</ng-container>